<!-- Orders -->
<mat-card
    class="daxa-card orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
                Plant list
            </h5>
        </mat-card-title>
        <!-- <mat-card-subtitle>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input
                    type="text"
                    class="input-search d-block w-100 border-none outline-0"
                    placeholder="Search plants..."
                    (keyup)="applyFilter($event)"
                    #input
                >
            </form>
        </mat-card-subtitle> -->
    </mat-card-header>

    <mat-card-content>
        <div class="orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource">

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                (change)="$event ? toggleAllRows() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()"
                            >
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)"
                            >
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- S-N Column -->
                    <ng-container matColumnDef="snId">
                        <th mat-header-cell *matHeaderCellDef>
                            S-N:
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.snId}}
                        </td>
                    </ng-container>

                    <!-- Plant name Column -->
                    <ng-container matColumnDef="plantName">
                        <th mat-header-cell *matHeaderCellDef>
                            Plant Name, City
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-black">
                            {{element.plantName.name}}, {{element.plantName.city}}
                        </td>
                    </ng-container>

                    <!-- Production Column -->
                    <ng-container matColumnDef="production">
                        <th mat-header-cell *matHeaderCellDef>
                            Production
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.production}} kWh
                        </td>
                    </ng-container>

                    <!-- Consumption Column -->
                    <ng-container matColumnDef="consumption">
                        <th mat-header-cell *matHeaderCellDef>
                            Consumption
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.consumption}} kWh
                        </td>
                    </ng-container>

                    <!-- Battery level Column -->
                    <ng-container matColumnDef="batteryLevel">
                        <th mat-header-cell *matHeaderCellDef>
                            Battery level
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.batteryLevel}}
                        </td>
                    </ng-container>

                    <!-- Date Column -->
                    <ng-container matColumnDef="startupDate">
                        <th mat-header-cell *matHeaderCellDef>
                            Startup Date
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.startupDate}}
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.status.online) {
                                <span class="daxa-badge online d-inline-block">
                                    {{element.status.online}}
                                </span>
                            }
                            @if (element.status.abnormal) {
                                <span class="daxa-badge abnormal d-inline-block">
                                    {{element.status.abnormal}}
                                </span>
                            }
                            @if (element.status.offline) {
                                <span class="daxa-badge offline d-inline-block">
                                    {{element.status.offline}}
                                </span>
                            }
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            Action
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info">
                                <button mat-button
                                    matTooltip="View Plant"
                                    matTooltipPosition="above"
                                    (click)="viewPlant(element)">
                                    <i class="material-symbols-outlined">
                                        {{element.action.view}}
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <!-- <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                    </tr> -->

                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>